import { render, staticRenderFns } from "./MatchesList.vue?vue&type=template&id=36b16a1c&scoped=true"
import script from "./MatchesList.vue?vue&type=script&lang=js"
export * from "./MatchesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b16a1c",
  null
  
)

export default component.exports